import ReactGA from "react-ga";

export const reactGaEvent = (category, action) => {
    ReactGA.event({
        category: category,
        action: action
    });
};